module.exports = __webpack_public_path__ + "img/IMG_5335.26524527.jpg";